import type { ButtonHTMLAttributes, ReactNode } from 'react';

type ButtonVariant = 'primary' | 'secondary' | 'danger' | 'ghost';

type ButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  variant?: ButtonVariant;
  loading?: boolean;
  icon?: ReactNode;
};

const variantClass: Record<ButtonVariant, string> = {
  primary: 'crystal-btn crystal-sapphire text-white disabled:opacity-45',
  secondary: 'crystal-btn crystal-smoky admin-text-strong disabled:opacity-45',
  danger: 'crystal-btn crystal-ruby text-white disabled:opacity-45',
  ghost: 'crystal-btn crystal-action-smoky admin-text disabled:opacity-45',
};

export function Button({
  variant = 'primary',
  loading = false,
  icon,
  className = '',
  disabled,
  children,
  type = 'button',
  ...props
}: ButtonProps) {
  return (
    <button
      {...props}
      type={type}
      disabled={disabled || loading}
      className={`inline-flex min-h-9 items-center justify-center gap-1.5 rounded-lg px-3 py-1.5 text-xs font-black focus:outline-none disabled:cursor-not-allowed ${variantClass[variant]} ${className}`}
    >
      {loading ? <span className="h-4 w-4 animate-spin rounded-full border-2 border-current border-r-transparent" aria-hidden="true" /> : icon}
      <span>{children}</span>
    </button>
  );
}

export default Button;
